import React from 'react';
import { Helmet } from 'react-helmet-async';

import TableComponent from '../app-rationalization/ARArchiveFlag/ARArchiveComponent';

const ArchiveFlag = () => (
  <>
    <Helmet>
      <title> Dashboard: Archive Flag</title>
    </Helmet>

    <TableComponent />
  </>
);

export default ArchiveFlag;
